module.exports = __webpack_public_path__ + "img/LATIN10_31.9aea95cd.jpg";